import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useContextSelector } from 'use-context-selector';
import { HelpLink } from '../../../../../common/components/HelpLink/HelpLink';
import { OnClickElsewhere } from '../../../../../common/components/OnClickElsewhere/OnClickElsewhere';
import { PersonaContext } from '../../HelperContexts';
import './SenderSelector.pcss';

type Props = {
  isDisabled: boolean;
  usePersona?: boolean;
  setUsePersona: (usePersona: boolean) => void;
};

export const SenderSelector = (props: Props) => {
  const { isDisabled, usePersona, setUsePersona } = props;

  const currentPersona = useContextSelector(
    PersonaContext,
    v => v.currentPersona,
  );

  const activeFacebookPage = useSelector(activeFacebookPageSelector);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const selectReplier = (usePersona: boolean) => {
    setUsePersona(usePersona);
    setIsDropdownOpen(false);
  };

  if (!activeFacebookPage || !currentPersona || isDisabled) {
    return null;
  }

  return (
    <>
      <div
        className="lc-sender--selector"
        onClick={() => setIsDropdownOpen(true)}
      >
        <div className="lc-sender--profile__indicator">
          {usePersona ? (
            <>
              <img
                className="lc-sender-profile__image"
                src={currentPersona.profilePictureUrl}
                alt="Persona Profile"
              />
              Respond as Agent
            </>
          ) : (
            <>
              <img
                className="lc-sender-profile__image"
                src={activeFacebookPage.squarePicture}
                alt="Facebook Page"
              />
              Respond as Page
            </>
          )}
          <i className="lc-sender-profile__down-arrow fas fa-chevron-down" />
        </div>
      </div>
      <HelpLink
        className="lc-sender-profile__help-link"
        href="https://mobilemonkey.com/help/article/di0r8zfm9k-agent-persona"
      />

      {isDropdownOpen && (
        <OnClickElsewhere
          handleClick={() => setIsDropdownOpen(false)}
          className="lc-sender--dropdown"
        >
          <div className="lc-sender--dropdown__header">
            Select Persona for Your Reply
          </div>
          <div
            className="lc-sender--dropdown__selection"
            onClick={() => selectReplier(false)}
          >
            <div>
              <img
                className="lc-sender--dropdown__image"
                src={activeFacebookPage.squarePicture}
                alt="Facebook Page"
              />
            </div>
            <div className="lc-sender--dropdown__text">
              {activeFacebookPage.name}
            </div>
            <div className="lc-sender--dropdown__check">
              {usePersona ? null : <i className="fas fa-check" />}
            </div>
          </div>
          <div
            className="lc-sender--dropdown__selection"
            onClick={() => selectReplier(true)}
          >
            <div>
              <img
                className="lc-sender--dropdown__image"
                src={currentPersona.profilePictureUrl}
                alt="Persona Profile"
              />
            </div>
            <div className="lc-sender--dropdown__text">
              {currentPersona.name}
            </div>
            <div className="lc-sender--dropdown__check">
              {usePersona ? <i className="fas fa-check" /> : null}
            </div>
          </div>
        </OnClickElsewhere>
      )}
    </>
  );
};
